module.exports = __webpack_public_path__ + "kpz.1f4a8e3d7cae7cc600bde4c2b79521f6.png";